"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = exports.AuthContextProvider = exports.AuthContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const AuthConnector_1 = __importDefault(require("./AuthConnector"));
const ProviderBuilder_1 = __importDefault(require("./ProviderBuilder"));
const types_1 = require("@elrond-giants/erdjs-auth/dist/types");
const dist_1 = require("@elrond-giants/erdjs-auth/dist");
const out_1 = require("@multiversx/sdk-core/out");
const useNetworkProvider_1 = require("../useNetworkProvider");
const AccountBalance_1 = __importDefault(require("../AccountBalance"));
const network_1 = require("../network");
const out_2 = require("@multiversx/sdk-network-providers/out");
const accounts_1 = require("@multiversx/sdk-network-providers/out/accounts");
const utils_1 = require("../utils");
const contextDefaultValue = {
    address: null,
    authenticated: false,
    nonce: 0,
    balance: new AccountBalance_1.default(0),
    guardian: new accounts_1.GuardianData({ guarded: false }),
    provider: null,
    env: "devnet",
    use2FABrowserInput: false,
    login: (provider, options) => __awaiter(void 0, void 0, void 0, function* () { return ""; }),
    logout: () => __awaiter(void 0, void 0, void 0, function* () { return true; }),
    getLedgerAccounts: (page, pageSize) => {
        return Promise.resolve([]);
    },
    increaseNonce: () => { return 0; },
    refreshAccount: () => { },
};
exports.AuthContext = (0, react_1.createContext)(contextDefaultValue);
const AuthContextProvider = ({ connector, env, children, projectId, enableWebview, webConnectionOptions, use2FABrowserInput = false }) => {
    const [account, setAccount] = (0, react_1.useState)(null);
    const [authConnector, setAuthConnector] = (0, react_1.useState)(() => {
        const authConnector = getConnector({
            connector,
            env,
            projectId,
            webConnectionOptions
        });
        authConnector.onChange = () => __awaiter(void 0, void 0, void 0, function* () {
            yield refreshAccount();
            setChangedAt(Date.now());
        });
        return authConnector;
    });
    const [changedAt, setChangedAt] = (0, react_1.useState)(Date.now());
    let networkProvider;
    const networkContext = (0, react_1.useContext)(useNetworkProvider_1.NetworkContext);
    if (networkContext !== undefined && networkContext.provider !== undefined) {
        networkProvider = networkContext.provider;
    }
    else {
        const url = network_1.network[env]["api"];
        networkProvider = new out_2.ApiNetworkProvider(url);
    }
    const refreshAccount = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const address = (_a = authConnector.provider) === null || _a === void 0 ? void 0 : _a.getAddress();
        if (address) {
            const data = yield networkProvider.getAccount(out_1.Address.fromBech32(address));
            const guardian = yield getGuardian(address, networkProvider);
            setAccount({
                nonce: data.nonce.valueOf(),
                balance: new AccountBalance_1.default(data.balance),
                guardian
            });
        }
        else {
            setAccount(null);
        }
    });
    (0, react_1.useEffect)(() => {
        if (!authConnector.initialised()) {
            (() => __awaiter(void 0, void 0, void 0, function* () {
                yield authConnector.initFromStorage();
                yield refreshAccount();
                setChangedAt(Date.now());
            }))();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (enableWebview && window !== undefined) {
            const params = new URLSearchParams(window.location.search);
            const accessToken = params.get("accessToken");
            if (accessToken) {
                authConnector.init(types_1.AuthProviderType.WEBVIEW);
            }
        }
    }, []);
    const value = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f;
        const state = (_a = authConnector.provider) === null || _a === void 0 ? void 0 : _a.toJson();
        return {
            address: (_b = state === null || state === void 0 ? void 0 : state.address) !== null && _b !== void 0 ? _b : null,
            authenticated: (_c = state === null || state === void 0 ? void 0 : state.authenticated) !== null && _c !== void 0 ? _c : false,
            nonce: (_d = account === null || account === void 0 ? void 0 : account.nonce) !== null && _d !== void 0 ? _d : 0,
            balance: (_e = account === null || account === void 0 ? void 0 : account.balance) !== null && _e !== void 0 ? _e : new AccountBalance_1.default(0),
            guardian: (_f = account === null || account === void 0 ? void 0 : account.guardian) !== null && _f !== void 0 ? _f : new accounts_1.GuardianData({ guarded: false }),
            provider: authConnector.provider,
            env,
            use2FABrowserInput,
            login: (provider, { token, ledgerAccountIndex } = {}) => __awaiter(void 0, void 0, void 0, function* () {
                var _g;
                if (((_g = authConnector.provider) === null || _g === void 0 ? void 0 : _g.getType()) !== provider) {
                    yield authConnector.init(provider);
                }
                if (null != ledgerAccountIndex && authConnector.provider instanceof dist_1.LedgerProvider) {
                    authConnector.provider.setAccount(ledgerAccountIndex);
                }
                // @ts-ignore
                return authConnector.provider.login(token);
            }),
            logout: () => {
                return authConnector.logout();
            },
            getLedgerAccounts: (page, pageSize) => __awaiter(void 0, void 0, void 0, function* () {
                var _h;
                if (!authConnector.initialised()
                    || ((_h = authConnector.provider) === null || _h === void 0 ? void 0 : _h.getType()) !== types_1.AuthProviderType.LEDGER) {
                    yield authConnector.init(types_1.AuthProviderType.LEDGER);
                }
                if (authConnector.provider instanceof dist_1.LedgerProvider) {
                    return authConnector.provider.getAccounts(page, pageSize);
                }
                return [];
            }),
            increaseNonce: () => {
                if (!account) {
                    return 0;
                }
                const acc = Object.assign(Object.assign({}, account), { nonce: account.nonce + 1 });
                setAccount(acc);
                return acc.nonce;
            },
            refreshAccount
        };
    }, [changedAt, account === null || account === void 0 ? void 0 : account.nonce]);
    return (0, jsx_runtime_1.jsx)(exports.AuthContext.Provider, { value: value, children: children });
};
exports.AuthContextProvider = AuthContextProvider;
const useAuth = () => {
    const context = (0, react_1.useContext)(exports.AuthContext);
    if (context === undefined) {
        throw new Error(`useAuth must be used within an AuthContextProvider.`);
    }
    return context;
};
exports.useAuth = useAuth;
const getConnector = ({ connector, env, projectId, webConnectionOptions }) => {
    if (connector !== undefined) {
        return connector;
    }
    const providerBuilder = new ProviderBuilder_1.default(env !== null && env !== void 0 ? env : "devnet", projectId, webConnectionOptions);
    return new AuthConnector_1.default(providerBuilder);
};
const getGuardian = (address, networkProvider) => __awaiter(void 0, void 0, void 0, function* () {
    if (networkProvider instanceof out_2.ApiNetworkProvider) {
        try {
            const guardian = yield networkProvider.getGuardianData(out_1.Address.fromBech32(address));
            return guardian;
        }
        catch (e) {
            return new accounts_1.GuardianData({ guarded: false });
        }
    }
    const networkConfig = yield networkProvider.getNetworkConfig();
    const guardianDataResponse = yield (0, utils_1.fetchGuardianData)(address, networkConfig.ChainID);
    return accounts_1.GuardianData.fromHttpResponse(guardianDataResponse);
});
